import styled from 'styled-components';

export const LabelText = styled.span``;

export const FieldContainer = styled.div`
  display: ${(props) => (props.isHidden ? 'none' : 'block')};
  width: 100%;
  ${(props) => props.css}
`;
